import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    transferId: z.string(),
    action: z.enum(["approve", "reject"]),
    /** `editedAt` in milliseconds of the version the approver reviewed. Absent or `null` means the client did not see an edit. */
    editedAt: z.number().nullish(),
  }),
  response: z.object({
    success: z.boolean(),
  }),
};
